import Vue from 'vue'
import Router from 'vue-router'
import Home from 'components/home'
import Account from 'components/account'
import Login from 'components/login'
import Confirm from 'components/confirm'
import Forgotpassword from 'components/forgotpassword'
import Recoverypassword from 'components/recoverypassword'
// FAQ: The question: the answerimport Privacy from 'components/privacy'
import Play from 'components/play'
import uploadPhone from 'components/uploadphone'
import PageNotFound from 'components/page_not_found'
import Contest from 'components/contest'
import Iban from 'components/iban'
import Phone from 'components/phone'
import NotActive from 'components/not_active'
import store from '../store'



Vue.use(Router)



const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const ifComplateAccount = (to, from, next) => {
	if ( !store.getters.isProfileLoaded && store.getters.isAuthenticated ) {
		store.watch(
			(state, getters) => getters.isProfileLoaded,
			(value) => {
				if (value === true) {
					proceed()
				}
			}
		)
	}else{
		proceed()
	}

	function proceed(){
		if ( store.getters.isAuthenticated ) {
			if ( store.getters.isComplateAccount ) {
				next()
				return
			}else{
				next()
			}
		}else{
			next()
			return
		}
	}
}
const moment = require('moment')
const ifIsStart = (to, from, next) => {

  var queryString = '?'
  var i = 0
  for( var x in  to.query ){


}


  if ( moment() > moment( process.env.START ) ) {
    next()
    return
  }

  console.log('NOT ACTIVE YET')

  next('/not_active')
}
const ifIsStart_intermedio = (to, from, next) => {

  if ( moment() > moment( process.env.START_INTERMEDIO ) ) {
    next()
    return
  }

  console.log('NOT ACTIVE YET')

  next('/')
}


export default new Router({
  mode: 'history',
  //base: '/staging/pharma/',
  base: '/',
  routes: [
    {
      path: '/not_active',
      name: 'NotActive',
      component: NotActive,
   },
	{
      path: '/',
      name: 'Home',
      component: Home,
	  beforeEnter: guards([ifIsStart,ifComplateAccount]),

  },
	{
      path: '/play/:id/:piva/:cod',
      name: 'Play',
      component: Play,
	  beforeEnter: guards([ifIsStart,ifIsStart_intermedio,ifComplateAccount, ifAuthenticated]),
  },
  {
    path: '/contest/:id/:piva/:cod',
    name: 'Contest',
    component: Contest,
    beforeEnter: guards([ifIsStart,ifIsStart_intermedio,ifAuthenticated]),
  },
  {
    path: '/iban',
    name: 'Iban',
    component: Iban,
    beforeEnter: guards([ifIsStart,ifComplateAccount]),

  },
  {
    path: '/phone/:id/:data',
    name: 'Phone',
    component: Phone,
    beforeEnter: guards([ifIsStart,ifComplateAccount]),

  },
  {
      path: '/account',
      name: 'Account',
      component: Account,
	  beforeEnter: guards([ifIsStart,ifIsStart_intermedio,ifComplateAccount, ifAuthenticated]),
  },
  {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: guards([ifIsStart,ifNotAuthenticated]),
  },
	{
      path: '/confirm',
      name: 'Confirm',
      component: Confirm,
      beforeEnter: guards([ifIsStart,ifIsStart_intermedio,ifAuthenticated]),
  },
	{
      path: '/forgot-password',
      name: 'Forgotpassword',
      component: Forgotpassword,
      beforeEnter: guards([ifIsStart,ifNotAuthenticated]),
  },
  /*{
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
},*/
	{
      path: '/recovery-password',
      name: 'Recoverypassword',
      component: Recoverypassword,
      beforeEnter: guards([ifIsStart,ifNotAuthenticated]),

  },
  {
    path: '/uploadPhone/:token',
    name: 'uploadPhone',
    component: uploadPhone,
    beforeEnter: guards([ifIsStart,ifIsStart_intermedio]),

  },
  {
      path :'*',
      name: 'PageNotFound',
      component: PageNotFound,
  }


  ],
})

// allows using multiple guards for routes
function guards(guards)
{
    return async (to, from, next) => {

        // a flag to discard remaining guards
        let changed = false;

        // handle next for multiple guards
        const mNext = function (value)
        {
            // prevent calling next after it is already resolved with a value
            if(changed) return;

            // if we have 'value' reslove next with the value and set changed flag
            if(typeof value != 'undefined')
            {
                changed = true;
                next(value);
            }
        };

        // call guards
        for (let i = 0; i < guards.length; i++)
        {
            if(changed) break;
            await guards[i](to, from, mNext);
        }

        // move on if none of guards resolved next with a value
        if(!changed) next();

    }
}



// WEBPACK FOOTER //
// ./src/router/index.js